export default "__VITE_ASSET__WCb6tQ5$__"